export default __webpack_public_path__ + "static/media/remeet-image-1.de6fb7d9.jpg";